import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import productDetails from './views/product-details'
import productPay from './views/product-pay'

export default [
  {
    path: RoutePathConstants.PRODUCT_DETAILS,
    name: 'productDetails',
    component: productDetails
  },
  {
    path: RoutePathConstants.PRODUCT_PAY,
    name: 'productPay',
    component: productPay
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/routers.js